import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import {
  mapConnectionToDTO,
  mapConnectionToUpdateDTO,
  mapPaginationToData,
} from '../mappers/connection.mapper';
import { ConnectionRequestsService } from './connection-requests.service';
import { ConnectionStateService } from './connection-state.service';
import { Connection, ConnectionDataMap, ConnectionType } from '../interfaces/connection-interface';

@Injectable({ providedIn: 'root' })
export class ConnectionsFacadeService {
  private connectionRequestsService = inject(ConnectionRequestsService);
  private connectionState = inject(ConnectionStateService);

  private refresh$ = new BehaviorSubject<void>(undefined);
  connections$ = this.refresh$.pipe(
    switchMap(() => this.connectionRequestsService.getConnections().pipe(mapPaginationToData())),
  );

  setNewConnection(type: ConnectionType) {
    this.connectionState.setNewConnection(type);
  }

  getCurrentConnection() {
    return this.connectionState.getCurrentConnection();
  }

  addConnection(connection: Connection, values: ConnectionDataMap[ConnectionType]) {
    return this.connectionRequestsService
      .addConnection(mapConnectionToDTO(connection, values))
      .pipe(tap(() => this.reset()));
  }

  updateConnection(connection: Connection, values: ConnectionDataMap[ConnectionType]) {
    return this.connectionRequestsService
      .updateConnection(mapConnectionToUpdateDTO(connection, values))
      .pipe(tap(() => this.reset()));
  }

  private reset() {
    this.refresh$.next();
  }

  setConnection(connection: Connection) {
    this.connectionState.setConnection(connection);
  }
}
